import { Control, Controller } from 'react-hook-form';
import { Checkbox, Radio, RadioGroup, Toggle } from 'rsuite';
import { SetupIPAHeader } from '../../SetupIPA/elements/SetupIPAHeader';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';
import { FormValues } from '../interfaces';
import { OtherPrices, PriceOption } from '../SetupIPADadosDeConcorrenciatypes';
import { CHEBOX_OPTIONS, OPTIONS } from '../utils/options';

export const PriceOptionsSection = ({ control, showOtherPrices }: { control: Control<FormValues>; showOtherPrices: boolean }) => {
  const toggle = OPTIONS.price_option.toggle;

  return (
    <div className={styles['setup-ipa__price-preference-competitor']}>
      <SetupIPAHeader
        title="Dados de concorrência no IPA"
        subtitle="Configure quais os dados de concorrência que você quer receber no IPA para a precificação regular."
      />
      <Controller
        name="price_option"
        control={control}
        render={({ field }) => (
          <RadioGroup {...field} value={field.value} onChange={value => field.onChange(value as PriceOption)}>
            {OPTIONS.price_option.options.map(option => (
              <div key={option.key} className={styles['setup-ipa__price-preference-competitor__option-radio']}>
                <Radio value={option.value}>
                  <div className={styles['text-container']}>
                    <h4>{option.title}</h4>
                    <span>{option.subtitle}</span>
                  </div>
                </Radio>
              </div>
            ))}
          </RadioGroup>
        )}
      />

      {showOtherPrices && (
        <div className={styles['setup-ipa__price-preference-competitor__option-checkbox']}>
          <h4>Outros tipos de preço</h4>
          <p>Defina em detalhes quais preços da concorrência receber no IPA.</p>
          <Controller
            name="other_prices"
            control={control}
            render={({ field }) => (
              <div className={styles['checkbox-container']}>
                {CHEBOX_OPTIONS.other_prices.options.map((option, index) => (
                  <div key={option.key} className={styles['setup-ipa__price-preference-competitor__option-checkbox-item']}>
                    <Checkbox
                      value={option.value as OtherPrices}
                      checked={index === 0 || field.value.includes(option.value as OtherPrices)}
                      disabled={index === 0}
                      onChange={() => {
                        if (index !== 0) {
                          const currentValue = field.value || [];
                          const optionValue = option.value as OtherPrices;
                          const isChecked = currentValue.includes(optionValue);

                          if (!isChecked) {
                            field.onChange([...currentValue, optionValue]);
                          } else {
                            const updatedValues = currentValue.filter(value => value !== optionValue);
                            field.onChange(updatedValues);
                          }
                        }
                      }}
                    >
                      <div className={styles['text-container']}>
                        <h4>{option.title}</h4>
                        <span>{option.subtitle}</span>
                      </div>
                    </Checkbox>
                  </div>
                ))}
              </div>
            )}
          />
        </div>
      )}

      {toggle.value && (
        <Controller
          name="limit_in_pmc"
          control={control}
          render={({ field }) => (
            <div className={styles['setup-ipa__price-preference-competitor__toggle']}>
              <div className={styles['text-container']}>
                <h4>{toggle.title}</h4>
                <span>{toggle.subtitle}</span>
              </div>
              <span className={styles['toggle-wrapper']}>
                <Toggle size="sm" checked={field.value} onChange={field.onChange} />
                <span>{toggle.label}</span>
              </span>
            </div>
          )}
        />
      )}
    </div>
  );
};
